import React from "react";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import WalletsItem from "./WalletsItem";

const WalletsList = ({ wallets, notification, setNotification, t }) => {
  if (!wallets) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (wallets.length === 0) {
    return <Alert severity="warning">{t("wallets.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="1440"
        size="14"
        className="wallet-table"
      >
        <StyledTableHead
          scroll="auto"
          col="8"
          className="wallet-table__head"
        >
          <div>
            {t("wallets.table.clientId")}
          </div>
          <div>
            {t("wallets.table.currency")}
          </div>
          <div>
            {t("wallets.table.paymentSystem")}
          </div>
          <div>
            {t("wallets.table.balance")}
          </div>
          <div>
            {t("wallets.table.project")}
          </div>
          <div>
            {t("wallets.table.service")}
          </div>
          <div>
            {t("wallets.table.wallet")}
          </div>
          <div>
            {t("wallets.table.tag")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {wallets.map((value, key) => (
            <WalletsItem
              notification={notification}
              setNotification={setNotification}
              value={value}
              key={key}
              t={t}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default WalletsList;